import keyBy from 'lodash.keyby';
import mapValues from 'lodash.mapvalues';

import {
    VirtualizedTableErrors,
    VirtualizedTableColumnKey,
    VirtualizedTableColumnWidthOffset,
    VirtualizedTableColumnWidth,
    VirtualizedTableColumn,
    VirtualizedTableItemKey,
    VirtualizedTableItemField,
    VirtualizedTableItemValue,
    VirtualizedTableItem,
    VirtualizedTableErrorMessage,
    VirtualizedTableColumnsSetAction,
    VirtualizedTableColumnWidthOffsetSetAction,
    VirtualizedTableColumnWidthSetAction,
    VirtualizedTableItemsSetAction,
    VirtualizedTableItemSetAction,
    VirtualizedTableItemValueSetAction,
    VirtualizedTableItemsValueSetAction,
    VirtualizedTableItemsDeleteAction,
    VirtualizedTableErrorsSetAction,
    VirtualizedTableErrorSetAction,
    VirtualizedTableErrorRemoveAction,
    VirtualizedTableResetAction,
    VirtualizedTableSubmitHasFailedSetAction,
    VirtualizedTableSubmitHasFailed
} from './types';
import {
    VIRTUALIZED_TABLE_COLUMNS_SET,
    VIRTUALIZED_TABLE_COLUMN_WIDTH_OFFSET_SET,
    VIRTUALIZED_TABLE_COLUMN_WIDTH_SET,
    VIRTUALIZED_TABLE_ITEMS_SET,
    VIRTUALIZED_TABLE_ITEM_SET,
    VIRTUALIZED_TABLE_ITEM_VALUE_SET,
    VIRTUALIZED_TABLE_ITEMS_VALUE_SET,
    VIRTUALIZED_TABLE_ITEMS_DELETE,
    VIRTUALIZED_TABLE_ERRORS_SET,
    VIRTUALIZED_TABLE_ERROR_SET,
    VIRTUALIZED_TABLE_ERROR_REMOVE,
    VIRTUALIZED_TABLE_RESET,
    VIRTUALIZED_TABLE_SUBMIT_HAS_FAILED
} from './constants';

export function setColumns(
    columns: VirtualizedTableColumn[]
): VirtualizedTableColumnsSetAction {
    // TODO: refactor to key
    const columnsKeyedByKey = keyBy(columns, 'value');

    return {
        type: VIRTUALIZED_TABLE_COLUMNS_SET,
        payload: {
            // TODO: refactor to key
            columnKeys: columns.map((column) => column.value),
            columnsKeyedByKey,
            columnWidths: mapValues(
                columnsKeyedByKey,
                (column) => column.width
            ),
            columnWidthOffsets: {}
        }
    };
}

export function setColumnWidthOffset(
    columnKey: VirtualizedTableColumnKey,
    columnWidthOffset: VirtualizedTableColumnWidthOffset
): VirtualizedTableColumnWidthOffsetSetAction {
    return {
        type: VIRTUALIZED_TABLE_COLUMN_WIDTH_OFFSET_SET,
        payload: {
            columnKey,
            columnWidthOffset
        }
    };
}

export function setColumnWidth(
    columnKey: VirtualizedTableColumnKey,
    columnWidth: VirtualizedTableColumnWidth
): VirtualizedTableColumnWidthSetAction {
    return {
        type: VIRTUALIZED_TABLE_COLUMN_WIDTH_SET,
        payload: {
            columnKey,
            columnWidth
        }
    };
}

export function setItems(
    items: VirtualizedTableItem[]
): VirtualizedTableItemsSetAction {
    const itemsKeyedByKey = keyBy(items, 'key');

    return {
        type: VIRTUALIZED_TABLE_ITEMS_SET,
        payload: {
            itemsKeyedByKey
        }
    };
}

export function setItem(
    items: VirtualizedTableItem[]
): VirtualizedTableItemSetAction {
    const itemsKeyedByKey = keyBy(items, 'key');

    return {
        type: VIRTUALIZED_TABLE_ITEM_SET,
        payload: {
            itemsKeyedByKey
        }
    };
}

export function setItemValue(
    itemKey: VirtualizedTableItemKey,
    itemField: VirtualizedTableItemField,
    itemValue: VirtualizedTableItemValue,
    options?: {
        ignoreValidation: boolean;
    }
): VirtualizedTableItemValueSetAction {
    return {
        type: VIRTUALIZED_TABLE_ITEM_VALUE_SET,
        payload: {
            itemKey,
            itemField,
            itemValue,
            options
        }
    };
}

export function setItemsValue(
    itemKeys: VirtualizedTableItemKey[],
    itemField: VirtualizedTableItemField,
    itemValue: VirtualizedTableItemValue
): VirtualizedTableItemsValueSetAction {
    return {
        type: VIRTUALIZED_TABLE_ITEMS_VALUE_SET,
        payload: {
            itemKeys,
            itemField,
            itemValue
        }
    };
}

export function deleteItems(
    itemKeys: VirtualizedTableItemKey[]
): VirtualizedTableItemsDeleteAction {
    return {
        type: VIRTUALIZED_TABLE_ITEMS_DELETE,
        payload: {
            itemKeys
        }
    };
}

export function setErrors(
    errors: VirtualizedTableErrors
): VirtualizedTableErrorsSetAction {
    return {
        type: VIRTUALIZED_TABLE_ERRORS_SET,
        payload: {
            errors
        }
    };
}

export function setError(
    itemKey: VirtualizedTableItemKey,
    itemField: VirtualizedTableItemField,
    errorMessage: VirtualizedTableErrorMessage
): VirtualizedTableErrorSetAction {
    return {
        type: VIRTUALIZED_TABLE_ERROR_SET,
        payload: {
            itemKey,
            itemField,
            errorMessage
        }
    };
}

export function removeError(
    itemKey: VirtualizedTableItemKey,
    itemField: VirtualizedTableItemField
): VirtualizedTableErrorRemoveAction {
    return {
        type: VIRTUALIZED_TABLE_ERROR_REMOVE,
        payload: {
            itemKey,
            itemField
        }
    };
}

export function resetVirtualizedTable(): VirtualizedTableResetAction {
    return {
        type: VIRTUALIZED_TABLE_RESET
    };
}

export function setSubmitHasFailed(
    submitHasFailed: VirtualizedTableSubmitHasFailed
): VirtualizedTableSubmitHasFailedSetAction {
    return {
        type: VIRTUALIZED_TABLE_SUBMIT_HAS_FAILED,
        payload: {
            submitHasFailed
        }
    };
}
